import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import Image from "next/image";

const TextAndImage = ({ attrs }) => {
  const block_data = attrs?.data;
  const { url: link_url, title: link_title, link_target } = block_data?.inhoud_link || {};
  const reverse = block_data?.de_rijen_spiegelen;

  return (
    <section className="px-4 mx-auto mb-16 md:mb-20 2xl:px-0 max-w-app image-text-section">
      <div className={`grid grid-cols-1 overflow-hidden gap-3 md:gap-6 lg:grid-cols-2`}>
        <div className={`w-full overflow-hidden rounded-md ${reverse == 1 ? "md:order-2" : ""}`}>
          <div
            className="relative w-full h-full md:min-h-[29rem] min-h-72"
            data-scroll
            data-scroll-speed="-0.05"
            data-scroll-enable-touch-speed
          >
            <Image
              src={block_data?.afbeelding?.url}
              alt={block_data?.afbeelding?.alt}
              className="object-cover !-top-[10%] !h-[120%]"
              fill
            />
          </div>
        </div>
        <div className="flex flex-col justify-center w-full px-8 py-10 bg-white rounded-md md:p-24">
          <h2 className="text-xl md:text-[2rem] mb-6 leading-tight">
            {block_data?.inhoud_titel}
          </h2>
          <div className="mb-5 lg:mb-6">{block_data?.inhoud_inhoud}</div>
          <div>
            {link_url && (
              <a
                href={link_url}
                target={link_target || "_self"}
                title={link_title || "Bekijk de collectie"}
                className="inline-block w-full md:w-fit"
              >
                <ButtonGsfurn
                  pill
                  color="primary"
                  className="w-full sm:w-fit"
                  needsArrow
                  fullWidth
                >
                  {link_title || "Bekijk de collectie"}
                </ButtonGsfurn>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextAndImage;
